import { includes as rincludes, flip, curry, equals, not } from 'rambda';
import {
  compose as lcompose,
  filter as lfilter,
  negate as lnegate,
  eq as leq,
} from 'lodash/fp';
import { filter } from 'fp-ts/ReadonlyArray';
import { chain, of } from 'fp-ts/Reader';
import { flow, pipe } from 'fp-ts/function';

export const includes = curry(flip(rincludes));

function toggle<T>(items: T[], item: T) {
  return lcompose(
    (a: boolean) => (a ? lfilter(lnegate(leq(item)))(items) : [...items, item]),
    includes(items)
  )(item);
}

export const toggleItem = curry(toggle);

export const toggleItem2 = (a: string) =>
  pipe(
    of<{ a: string; items: string[] }, string>(a),
    chain(hasItem),
    chain(removeOrAdd)
  );
const hasItem =
  (a: string) =>
  (env: { a: string; items: string[] }): boolean =>
    includes(env.items)(a);
const removeOrAdd = (a: boolean) => (env: { a: string; items: string[] }) =>
  a
    ? filter<string>(flow(equals(env.a), not))(env.items)
    : [...env.items, env.a];
